import { gsap } from './gsapSetup';

// const hero = document.querySelector('.hero');

function animateHero(el) {

    const cardsContainer = el.querySelector('.hero__cards');
    if (!cardsContainer) return;
    
    const cards = [...cardsContainer.querySelectorAll('.hero__card')];
    if (!cards.length) return;
    
    const heroContent = el.querySelector('.hero__content');
    
    const tl = gsap.timeline();
    
    tl.from(cardsContainer, {
        scale: 1.2,
        duration: 0.5,
        delay: 0.75,
        ease: "quad.out"
    });
    
    tl.from(cards, {
        x: 0,
        y: 0,
        rotation: 0,
        duration: 0.75,
        stagger: 0.3,
        ease: "quad.out"
    }, "-=0.5");
    
    if (heroContent) {
        tl.from(heroContent, {
            y: 50,
            opacity: 0,
            duration: 0.75,
            ease: "quad.out"
        }, "-=0.1")
    }
}

document.fonts.ready.then(() => {
    [...document.querySelectorAll('.hero')].map(animateHero)
})
